import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

import ActivityBadge from '../ActivityBadge';

const PAW_ICON = require('./paw.svg');

export default class DogCard extends Component {
  constructor(props) {
    super(props);

    switch (this.props.status) {
      default:
        this.status = '';
        break;
      case 'accepted':
        this.status = "You're Dog Sharing";
        this.statusClass = styles.card_status_sharing;
        break;
      case 'pending':
        this.status = 'Request Pending...';
        this.statusClass = styles.card_status_pending;
        break;
      case 'declined':
        this.status = 'Share Declined';
        this.statusClass = styles.card_status_declined;
        break;
      case 'ended':
        this.status = 'Sharing ended';
        this.statusClass = styles.card_status_declined;
        break;
      case 'favourite':
        this.status = "Let's dog share";
        this.statusClass = styles.card_status_sharing;
        break;
    }
  }

  getDogImage() {
    if (this.props.image && this.props.image.length > 6) {
      return this.props.image;
    }

    return '/images/default_dog.jpg';
  }

  getProfileLink() {
    if (this.props.member) {
      return `/profile/${this.props.id}`;
    }

    if (this.props.id) {
      return `/pooch/${this.props.id}`;
    }

    return '/join';
  }

  renderPawIcon() {
    return (
      <Isvg
        cacheGetRequests
        src={PAW_ICON}
        className={css(styles.paw_icon, styles.paw_icon_blue)}
      />
    );
  }

  render() {
    const hoverText =
      this.props.member || this.props.id ? 'View Profile' : 'Sign up to view profile';

    const dynamicStyles = StyleSheet.create({
      card_image: {
        ':after': {
          content: `"${hoverText}"`,
        },
      },
    });

    return (
      <Link
        to={this.getProfileLink()}
        className={css(
          styles.card,
          this.props.signup ? styles.card_signup : null,
          this.props.status ? styles.card_has_status : false,
        )}
      >
        <div className={css(styles.card_image, dynamicStyles.card_image)}>
          <img className={css(styles.card_photo)} src={this.getDogImage()} alt={this.props.name} />
        </div>
        <div className={css(styles.card_details)}>
          <div className={css(styles.card_meta)}>
            <div className={css(styles.card_name)}>{this.props.name}</div>
            <div className={css(styles.card_breed)}>{this.props.breed}</div>
            <div className={css(styles.card_suburb)}>
              {this.props.suburb ? this.props.suburb.title : ' '}
            </div>
            {this.props.proximityText && (
              <div className={css(styles.card_proximity)}>{this.props.proximityText}</div>
            )}
          </div>
          {Theme.isMobile ? (
            <Link to={this.getProfileLink()} className={css(styles.card_view)}>
              View
            </Link>
          ) : (
            <div className={css(styles.card_summary)}>{this.props.summary}</div>
          )}
          {Theme.isMobile ? null : (
            <div className={css(styles.card_badges)}>
              {this.props.interests.slice(0, 4).map(interest => (
                <ActivityBadge key={interest.title} activity={interest.title} />
              ))}
            </div>
          )}
          {this.status ? (
            <div className={css(styles.card_status, this.statusClass)}>
              {this.props.status === 'accepted' ? this.renderPawIcon() : false}
              {this.status}
            </div>
          ) : null}
        </div>
      </Link>
    );
  }
}

DogCard.defaultProps = {
  id: null,
  status: null,
  signup: false,
  interests: [],
  member: false,
  image: null,
  summary: null,
  breed: 'Unknown',
  suburb: null,
  proximityText: null,
};

DogCard.propTypes = {
  id: PropTypes.number,
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  breed: PropTypes.string,
  summary: PropTypes.string,
  status: PropTypes.string,
  signup: PropTypes.bool,
  interests: PropTypes.array,
  member: PropTypes.bool,
  suburb: PropTypes.string,
  proximityText: PropTypes.string,
};

const styles = StyleSheet.create({
  card_status: {
    padding: '12px 15px',
    margin: '25px -18px -18px',
    fontSize: 15,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    textAlign: 'center',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    backgroundColor: Theme.error,
    position: 'absolute',
    bottom: 0,
    width: '100%',

    ':after': {
      bottom: '100%',
      right: 40,
      border: 'solid transparent',
      content: '""',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
      borderColor: 'rgba(232, 94, 94, 0)',
      borderBottomColor: '#E85E5E',
      borderWidth: 10,
      marginLeft: -10,
    },
  },
  card_status_sharing: {
    backgroundColor: '#f4f4f4',
    color: '#39b4d6',

    ':after': {
      borderBottomColor: '#f4f4f4',
    },
  },
  card_status_pending: {
    backgroundColor: '#021a36',
    color: Theme.white,

    ':after': {
      borderBottomColor: '#021a36',
    },
  },
  card: {
    position: 'relative',
    display: 'block',
    width: 262,
    minWidth: 262,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: Theme.white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Theme.lighter_grey,

    [Theme.mobile_query]: {
      width: '100%',
      paddingBottom: 38,
    },

    '@media screen and (min-width: 625px) and (max-width: 768px)': {
      width: 262,
    },

    ':hover > div:first-child:after': {
      opacity: 1,
    },
  },
  card_has_status: {
    marginBottom: 50,
  },
  card_details: {
    [Theme.mobile_query]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  card_meta: {
    [Theme.mobile_query]: {
      flexGrow: 1,
    },
  },
  card_view: {
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: 15,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#39b4d6',
  },
  card_image: {
    position: 'relative',
    display: 'block',
    margin: '-18px -18px 10px',
    backgroundColor: Theme.black,

    ':before': {
      display: 'block',
      width: '100%',
      paddingTop: 'calc((260 / 276) * 100%)',
      content: '""',
    },

    ':after': {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      padding: 65,
      fontFamily: Theme.font_family_secondary,
      fontWeight: Theme.font_weight_secondary,
      fontSize: 15,
      lineHeight: 1.73,
      letterSpacing: 2,
      textAlign: 'center',
      textTransform: 'uppercase',
      color: Theme.white,
      backgroundColor: 'rgba(86, 197, 255, 0.9)',
      boxSizing: 'border-box',
      opacity: 0,
      transition: 'opacity 300ms',
    },
  },
  card_photo: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  card_name: {
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 20,
    color: Theme.black,
    lineHeight: 1.5,
  },
  card_breed: {
    marginBottom: 7,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 15,
    color: '#000e1f',

    [Theme.mobile_query]: {
      marginTop: 6,
      marginBottom: 0,
    },
  },
  card_suburb: {
    marginBottom: 7,
    fontFamily: Theme.font_family_primary,
    fontWeight: 'bold',
    fontSize: 15,
    color: '#000e1f',

    [Theme.mobile_query]: {
      marginTop: 6,
      marginBottom: 0,
    },
  },
  card_proximity: {
    marginTop: 4,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: 15,
    color: Theme.primary,

    [Theme.mobile_query]: {
      marginTop: 6,
      fontSize: 15,
    },
  },
  card_summary: {
    marginBottom: 12.7,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    color: '#828282',
  },
  card_badges: {
    display: 'flex',
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: Theme.white,
  },
  paw_icon_blue: {
    fill: '#39b4d6',
  },
});



// WEBPACK FOOTER //
// ./src/components/DogCard/index.js